import * as React from 'react';
import { GetTodosAck, ITile, Project } from 'matrix-requirements-sdk/client';
import { AnalyticsTile, StylesProvider, Line, LineData } from '@matrixreq/ui';
import { createRoot, Root } from 'react-dom/client';
import { sdkInstance } from './Instance';
import { Plugin } from './Plugin';
import { DashboardPage } from './DashboardPage';
import { createRef } from 'react';

const globalMatrix = sdkInstance.globalMatrix;
const matrixSession = sdkInstance.matrixSession;

interface IState {
  data?: LineData[];
  isLoading?: boolean;
  loaded?: string;
  label?: string;
}
export class Tile implements ITile {
  root: Root = undefined;
  private ref: React.RefObject<TileComponent>;

  canBeRendered() {
    return true;
  }
  getTitle() {
    return 'Traceability overview';
  }
  getOrder() {
    return 1000;
  }
  async render(containerElement: HTMLElement) {
    if (this.root !== undefined) {
      this.root.unmount();
    }
    let project = await sdkInstance.matrixsdk.openCurrentProjectFromSession();

    this.root = createRoot(containerElement);
    this.ref = createRef<TileComponent>();
    this.root.render(
      <StylesProvider>
        <TileComponent ref={this.ref} Project={project}></TileComponent>
      </StylesProvider>,
    );
  }
  async refresh() {
    return this.ref.current.refresh();
  }
  async canBeRenderedAsync() {
    return true;
  }
}

interface IProps {
  Project: Project;
}

class TileComponent extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
    // Get the notifications from the cache
    setTimeout(() => this.refresh(), 100);
  }
  load() {}
  componentDidMount() {}

  componentWillUnmount() {}

  async refresh() {
    let created: LineData = {
      id: 'created',
      label: 'Created',
      data: [],
      color: 'green',
    };
    let pending: LineData = {
      id: 'pending',
      label: 'Pending',
      data: [],
      color: 'red',
    };

    this.state = { isLoading: true, data: [created, pending] };

    let project = await sdkInstance.matrixsdk.openCurrentProjectFromSession();

    const allNotifications: GetTodosAck = await project.getTodos(
      undefined,
      true,
      true,
    );
    let data = DashboardPage.calculateCumulativeChart(allNotifications.todos);

    for (let i = 1; i < data.date.length; i++) {
      created.data.push({
        x: moment(data.date[i]).format('YYYY-MM-DD'),
        y: data.created[i],
      });
      pending.data.push({
        x: moment(data.date[i]).format('YYYY-MM-DD'),
        y: data.remainings[i],
      });
    }
    let graphData: LineData[] = [created, pending];

    const lineData = graphData;

    this.setState((state, prop) => ({
      data: lineData,
      label: 'Notifications',
      isLoading: false,
      loaded: new Date().toISOString(),
    }));
  }
  render() {
    return (
      <AnalyticsTile
        id={'com.matrixreq.core.noo'}
        key={'com.matrixreq.core.noo'}
        name={'Notifications overview'}
        lastUpdated={this.state.loaded ?? ' ?'}
        isLoading={this.state.isLoading}
        onRefreshAction={() => {
          this.refresh();
        }}
        onViewAction={() => {
          window.open(
            `${globalMatrix.matrixBaseUrl}/${matrixSession.getProject()}/${Plugin.config.dashboard.id}`,
            '_self',
          );
        }}
      >
        <Line data={this.state.data} key={'noo'}></Line>
      </AnalyticsTile>
    );
  }
}
